import { render } from "./NewSection.vue?vue&type=template&id=660d1bba&scoped=true"
import script from "./NewSection.vue?vue&type=script&lang=js"
export * from "./NewSection.vue?vue&type=script&lang=js"

import "./NewSection.vue?vue&type=style&index=0&id=660d1bba&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660d1bba"]])

export default __exports__